import venueImg from "../../assets/venue.jpg";

export default function VenueSection() {
  return (
    <section className="relative h-[500px] w-full overflow-hidden">
      {/* Background map / venue image */}
      <div className="w-full h-[100%] sm:h-[500px] md:h-[600px] relative">
        <img
          src={venueImg}
          alt="Venue location"
          className="w-full h-full object-cover"
          data-aos="zoom-in"
        />
      </div>

      <div className="absolute inset-0 bg-black/40" />

      {/* Overlay Info Card */}
      <div className="absolute inset-0 flex items-center justify-end px-0 md:px-[10%]">
        <div
          className="bg-white/90 backdrop-blur-md shadow-lg p-8 max-w-lg"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <h2
            className="text-2xl md:text-3xl text-gray-900 mb-4 favela font-bold"
            data-aos="fade-down"
            data-aos-delay="400"
          >
            Venue & Location
          </h2>
          {/* <p
            className="text-gray-700 font-medium mb-2"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            Location
          </p> */}
          <p
            className="text-gray-600 mb-4"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            Private salon at W1A, Central London <br /> full details after
            booking
          </p>
          <p
            className="text-gray-600 mb-2"
            data-aos="fade-up"
            data-aos-delay="700"
          >
            <strong>Date: </strong> Saturday, 06 December, 2025
          </p>
          <p
            className="text-gray-600 mb-2"
            data-aos="fade-up"
            data-aos-delay="800"
          >
            <strong>Time:</strong> Evening (exact schedule on ticket)
          </p>
          <p
            className="text-gray-600 mb-2"
            data-aos="fade-up"
            data-aos-delay="900"
          >
            <strong>Closest Tube:</strong> Green Park, Piccadilly Circus
          </p>
          <p
            className="text-gray-600 mb-2"
            data-aos="fade-up"
            data-aos-delay="900"
          >
            <strong>Dress code:</strong> Black Tie
          </p>
          <p
            className="text-gray-600 mb-2"
            data-aos="fade-up"
            data-aos-delay="900"
          >
            <strong>Dietary: </strong> Allergens accommodated with 72 hours’
            notice
          </p>
        </div>
      </div>
    </section>
  );
}
